import React from "react";
import { gaTrackCta } from "../../analytics/ga4";
import { C, NAV_ITEMS } from "../../core/constants";
import { useI18n } from "../../features/i18n/LocaleProvider";
import CreditsChip from "./CreditsChip";
import NavItemButton from "./NavItemButton";

export default function Sidebar({ page, setPage, acc, creditsBalance, activeSubscription = false, showCreditsChip = true, analyticsScreen }) {
  const { t } = useI18n();
  const screen = analyticsScreen || page;
  return (
    <div
      style={{
        width: 240,
        flexShrink: 0,
        background: "rgba(8,12,32,0.95)",
        borderRight: "1px solid rgba(255,255,255,0.06)",
        backdropFilter: "blur(20px)",
        display: "flex",
        flexDirection: "column",
        padding: "0 0 24px",
        position: "sticky",
        top: 0,
        height: "100vh",
        overflowY: "auto",
      }}
    >
      <div style={{ padding: "28px 24px 32px", borderBottom: "1px solid rgba(255,255,255,0.05)" }}>
        <div style={{ fontFamily: "'Cormorant Garamond',serif", fontSize: 24, fontWeight: 500, color: acc.primary }}>✦ Ecliptica</div>
        <div style={{ fontSize: 11, color: C.textMuted, letterSpacing: "0.1em", marginTop: 4 }}>{t("topbar_celestial_intelligence")}</div>
      </div>
      <nav style={{ flex: 1, padding: "16px 12px" }}>
        {NAV_ITEMS.map((n) => {
          const active = page === n.id;
          return (
            <NavItemButton
              key={n.id}
              item={n}
              active={active}
              acc={acc}
              label={t(n.labelKey)}
              variant="sidebar"
              onClick={() => {
                gaTrackCta({ cta_id: `nav_${n.id}`, cta_label: t(n.labelKey), destination: n.id, screen_class: screen });
                setPage(n.id);
              }}
            />
          );
        })}
      </nav>
      {showCreditsChip && (
        <CreditsChip acc={acc} creditsBalance={creditsBalance} activeSubscription={activeSubscription} />
      )}
    </div>
  );
}
